import { Component, Input, OnChanges, OnDestroy, SimpleChanges, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisTranslationService } from '../service/his-translation.service';
import { Language } from '../model/language';
import { AutoCompleteSelectEvent } from 'primeng/autocomplete';

@Component( {
    selector: 'his-translation-selector',
    templateUrl: './his-translation-selector.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisTranslationSelectorComponent implements OnChanges, OnDestroy {
    private hisTranslationService = inject(HisTranslationService);

    @Input() defaultLanguage?: Language;

    public currentLanguage: Language;
    public isHidden = true;
    public filteredTranslationLanguages: Language[];
    public translationsLanguages: Language[];

    ngOnChanges( changes: SimpleChanges ): void {
        this.isHidden = !changes.defaultLanguage.currentValue;
        if ( changes.defaultLanguage.currentValue
            && changes.defaultLanguage.currentValue?.id !== changes.defaultLanguage.previousValue?.id ) {
            // get all possible translationLangages
            this.translationsLanguages = this.hisTranslationService.translationsLanguages( changes.defaultLanguage.currentValue );

            // set the initial value to manipulated defaultLanugage
            this.currentLanguage = this.translationsLanguages[0];
        }
    }

    ngOnDestroy(): void {
        this.hisTranslationService.setTranslationLanguage( undefined );
    }

    filterTranslationLanguages( event: { query: string } ) {
        this.filteredTranslationLanguages = [];
        for ( let lang of this.translationsLanguages ) {
            if ( lang.text.toLowerCase().indexOf( event.query.toLowerCase() ) === 0 ) {
                this.filteredTranslationLanguages.push( lang );
            }
        }
    }

    onTranslationLanguageSelect( event: AutoCompleteSelectEvent ) {
        let selectedLanguage = event.value as Language;
        if ( !this.defaultLanguage || this.defaultLanguage.id === selectedLanguage.id ) {
            this.hisTranslationService.setTranslationLanguage( undefined );
        } else {
            this.hisTranslationService.setTranslationLanguage( selectedLanguage );
        }
    }
}
